import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

export interface GroupingItem {
  label: string;
  value: string;
}
export interface GroupingOption {
  label: string;
  value: string;
  items: GroupingOption[] | GroupingItem[];
}
@Component({
  selector: 'app-unit-filter',
  templateUrl: './unit-filter.component.html',
  styleUrls: ['./unit-filter.component.scss'],
})
export class UnitFilterComponent implements OnInit, OnChanges {
  @Output() leakedUnits = new EventEmitter<any>();
  @Output() leakedIMEIs = new EventEmitter<any>();
  @Input() onClean: boolean = true;
  @Input() disabled: boolean = false;
  @Input() units: any[] = [];
  @Input() idOperation: string = 'idOperation';
  @Input() idGroup: string = 'idGrupo';
  @Input() idConvoy: string = 'idConvoy';
  @Input() nameOperation: string = 'operation';
  @Input() nameGroup: string = 'group';
  @Input() nameConvoy: string = 'convoy';
  @Input() placeholderOperation: string = 'Seleccione una Operación ...';
  @Input() placeholderGroup: string = 'Seleccione una Operación Primero ...';
  @Input() placeholderConvoy: string = 'Seleccione un Grupo Primero ...';

  constructor() {}
  // ---------------------------------------------------------------------------
  operations: GroupingOption[] = [];
  selectedOperation: GroupingOption | undefined;
  groups: GroupingOption[] = [];
  selectedGroup: GroupingOption | undefined;
  convoys: GroupingItem[] = [];
  selectedConvoy: GroupingItem | undefined;

  disabledOperation = false;
  disabledGroup = true;
  disabledConvoy = true;

  // ---------------------------------------------------------------------------
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.units) {
      if (!changes.units.firstChange) this.updateDropdowns();
    }
    if (changes.onClean && !changes.onClean.firstChange) {
      this.onClearSelection();
    }
  }

  // ---------------------------------------------------------------------------
  private getUniqueOptions(
    idKey: string,
    nameKeys: string[],
    fk?: GroupingItem,
  ): GroupingItem[] {
    const uniqueMap = new Map();
    for (const v of this.units) {
      if (fk && v[fk.label] !== fk.value) continue;
      const id = v[idKey];
      if (id != null && !uniqueMap.has(id)) {
        let name = '';
        for (const key of nameKeys) {
          if (v[key]) {
            name = v[key];
            break;
          }
        }
        uniqueMap.set(id, { value: id, label: name });
      }
    }
    return Array.from(uniqueMap.values()).sort(
      (a, b) => (a.value || 0) - (b.value || 0),
    );
  }
  private updateDropdowns() {
    this.operations = this.getUniqueOptions(this.idOperation, [
      this.nameOperation,
    ]).map((o) => ({
      ...o,
      items: this.getUniqueOptions(this.idGroup, [this.nameGroup], {
        label: this.idOperation,
        value: o.value,
      }).map((g) => ({
        ...g,
        items: this.getUniqueOptions(this.idConvoy, [this.nameConvoy], {
          label: this.idGroup,
          value: g.value,
        }),
      })),
    }));
  }

  // ---------------------------------------------------------------------------
  onChangeOperation() {
    this.disabledGroup = false;
    this.selectedGroup = undefined;
    this.groups = (this.selectedOperation?.items as GroupingOption[]) || [];
    this.groups.length == 0
      ? (this.disabledGroup = true)
      : (this.disabledGroup = false);
    this.onChangeGroup();
  }
  onChangeGroup() {
    this.disabledConvoy = false;
    this.selectedConvoy = undefined;
    this.convoys = (this.selectedGroup?.items as GroupingItem[]) || [];
    this.convoys.length == 0
      ? (this.disabledConvoy = true)
      : (this.disabledConvoy = false);
    this.onChangeConvoy();
  }
  onChangeConvoy() {
    this.filterUnits();
  }
  onClearSelection() {
    this.selectedOperation = undefined;
    this.selectedGroup = undefined;
    this.selectedConvoy = undefined;
    this.filterUnits();
  }

  // ---------------------------------------------------------------------------
  filterUnits() {
    let filteredUnits = this.units;
    if (this.selectedOperation) {
      filteredUnits = filteredUnits.filter(
        (u) => u[this.idOperation] === this.selectedOperation?.value,
      );
    }
    if (this.selectedGroup) {
      filteredUnits = filteredUnits.filter(
        (u) => u[this.idGroup] === this.selectedGroup?.value,
      );
    }
    if (this.selectedConvoy) {
      filteredUnits = filteredUnits.filter(
        (u) => u[this.idConvoy] === this.selectedConvoy?.value,
      );
    }
    console.log('Saints[UnitFilter](filterUnits) ---', filteredUnits);
    this.leakedUnits.emit(filteredUnits);
    this.leakedIMEIs.emit(filteredUnits.map((f) => f.GNSSIMEI));
  }
}
